import  React from 'react'
import { GrantAgreementHistoryModel } from '../../../models/GrantAgreementHistoryModel'

interface Props {
	issueHistory: GrantAgreementHistoryModel[]
}

const GrantAgreementHistoryTable : React.FC<Props> = ({ issueHistory }) => {
  if (issueHistory.length === 0) {
    return <>No issue history found. This is the first version of the grant agreement.</>
  }
  return (
    <table className="table">
    <thead>
      <tr>
        <th scope="col">
          Issued Date
        </th>
      </tr>
    </thead>
    <tbody>
      {issueHistory.map((ih: GrantAgreementHistoryModel, idx: number) => (
          <tr key={`${idx}ih-row`}>
            <td>{ih.issuedDate}</td>
          </tr>
        ))}
    </tbody>
  </table>
  )
}

export default GrantAgreementHistoryTable
